import styles from './email-components.module.scss';
import { Col, Row } from 'reactstrap';
import { useContext, useState } from 'react';
import { useGetRequestNewHook, useMakeRequestHook } from '../requestUtils';
import { Accordion, AccordionDetails, AccordionSummary, Container, Froala, Icon, List, MenuItem, PrimaryButton, SecondaryButton, Select, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { IEmailVariables } from '../_models/email-variables';
import { EmailVariable } from '../edit-email/edit-email';
import { IEmailComponent } from '../_models/email-component';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface EmailComponentsProps { }

export function EmailComponents(props: EmailComponentsProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [name, setName] = useState('');
  const [htmlContent, setHtmlContent] = useState<string | undefined>("");
  const [selectedComponentId, setSelectedComponentId] = useState<string | undefined>(undefined);

  const { data: components, getData }: { data: IEmailComponent[], getData: () => void } = useGetRequestNewHook(`admin/emailcomponents`, []);
  const { data: variables }: { data: IEmailVariables } = useGetRequestNewHook(`admin/emailvariables`, []);

  const handleSetSelectedComponent = (event: any) => {
    setSelectedComponentId(event.target.value);
    const selectedComponent = components.find(c => c.id === event.target.value);
    if (selectedComponent) {
      setName(selectedComponent.name);
      setHtmlContent(selectedComponent.htmlContent);
    }
    else {
      setName('');
      setHtmlContent('');
    }
  };

  const handleUpdateComponent = () => {
    makeRequest(`emailComponents`, 'PUT', {
      id: selectedComponentId,
      name: name,
      htmlContent: htmlContent
    });
    setSnackbarMessage({ content: t("emailComponents.componentChanged"), type: "success" });
  };

  const handleDeleteComponent = () => makeRequest(`emailComponents/${selectedComponentId}`, 'DELETE').then(result => {
    setSnackbarMessage({ content: t("emailComponents.componentDeleted"), type: "success" });
    getData();
    setSelectedComponentId(undefined);
    setName('');
    setHtmlContent('');
  });

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row className='mb-3'>
        <Col>
          <Select
            label={t("standard.selectTriggerType")}
            name='component'
            displayEmpty
            value={selectedComponentId || ""}
            onChange={handleSetSelectedComponent}>
            <MenuItem value={""} key={""}>{t("standard.new")}</MenuItem>
            {components.map(c =>
              <MenuItem value={c.id} key={c.id}>{c.name}</MenuItem>)}
          </Select>
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col lg={6} xxl={4}>
          <TextField
            fullWidth
            label={t("standard.name")}
            name='name'
            value={name}
            onChange={(event: any) => setName(event.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12} xxl={8} className='mb-3'>
          <Froala
            maxHeight={800}
            model={htmlContent}
            onModelChanged={setHtmlContent}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={6} xxl={6} className='mb-3'>
          {Object.keys(variables).map((key) => {
            //@ts-ignore
            const content = variables[key];
            if (!content) return null;
            return (
              <Accordion>
                <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
                  {key} {t("standard.variables")}
                </AccordionSummary>
                <AccordionDetails>
                  <List dense>
                    {Object.keys(content).map((innerKey) => {
                      return <EmailVariable name={content[innerKey]} handle={innerKey} />;
                    })}
                  </List>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Col>
      </Row>
      <PrimaryButton
        onClick={handleUpdateComponent}
        variant='contained'
        className="me-5">
        {t("emailComponents.saveComponent")}
      </PrimaryButton>
      {selectedComponentId && <SecondaryButton
        onClick={handleDeleteComponent}
        variant='contained'>
        {t("emailComponents.deleteComponent")}
      </SecondaryButton>}
    </Container>
  );
}

export default EmailComponents;